<template lang="pug">
Field.textarea(
  :required="Boolean(required)"
  :label="label"
  :errors="!touched ? [] : errors"
)
  textarea(
    v-bind="bindAttrs"
    @blur="touched = true"
    :class="{\
      'input-touched': touched,\
      'input-error': errors.length > 0\
    }"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    :maxlength="maxlength"
  )
</template>

<script setup lang="ts">
import { ref, computed, useAttrs, watch } from 'vue'
import { useRogue } from '../../js/rogue'

type Props = {
  modelValue?: string | null
  label?: string | null
  required?: boolean | string
  maxlength?: number | null
}

const props = withDefaults(defineProps<Props>(), {
  modelValue : null,
  label      : null,
  required   : false,
  maxlength  : null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const errors = ref<string[]>([])
const touched = ref<boolean>(false)

const attrs = useAttrs()
const bindAttrs = computed(() => {
  const { class: _class, style: _style, label, ...rest } = attrs as any
  
  return rest
})

const rogue = useRogue()

function validate() {
  const newErrors: string[] = []
  const val = (props.modelValue || '').toString().trim()
  if (props.required && val.length === 0) {
    if (typeof props.required === 'string' && props.required !== 'true') {
      newErrors.push(props.required)
    } else if (props.label) {
      newErrors.push(rogue.__('Please enter your {fieldName}.', { fieldName: props.label.toLowerCase() }))
    } else {
      newErrors.push(rogue.__('Required Field'))
    }
  }

  errors.value = newErrors
}

watch(() => props.modelValue, () => validate(), { immediate: true })

</script>

<style lang="scss" scoped>
  .textarea {
    textarea {
      font-family: $font-sans-serif;
      font-size: $size-xs;
      line-height: $line-height-m;
      display: block;
      height: 100px;
      padding: $space-xs;
      resize: vertical;
      border: 1px solid $color-gray;
      border-radius: 1px;
      width: 100%;

      &.input-error.input-touched {
        border: $border-width-thin solid $color-red;
      }
    }
  }
</style>
